import React, { useEffect, useState } from "react";
import MasterTable from "../common/MasterTable";
import CustomAlert from "../../helpers/CustomAlert";
import { format, parse } from "date-fns";
import LedgeFilterModal from "./LedgerFilterModal";
import Loader from "../Loader/Loader";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import FullStatement from "../transactionReport/FullStatement";
import DownloadReport from "../transactionReport/DownloadReport";
import confetti from "canvas-confetti";
import { useSelector, useDispatch } from "react-redux";
// import { useDispatch } from "react-redux";
import { setBalance } from "../store/balance/balanceSlice";
import { formatDateToYYYYMMDD } from "../../helpers/DateHelpers";
import HeaderWithBreadcrumb from "../common/HeaderWithBreadcrumb";
import FilterBar from "../common/FilterBar";
import { DR_CR_OPTIONS } from "../common/filterOptions";

const defaultFilterData = {
  companyId: "",
  fromDate: "",
  toDate: "",
  fromAmount: "",
  toAmount: "",
  drcr: "",
  txnType: [],
  drCr: "",
  search: "",
};

const Ledger = ({ fetchData }) => {
  const pageSize = 10;
  const { user } = useSelector((state) => state.auth);

  const [noData, setNoData] = useState(false);
  const [noDowRepData, setNoDowRepData] = useState(false);

  const [editData, setEditData] = useState({});
  const [ledgerData, setLedgerData] = useState([]);
  const [modalAction, setModalAction] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingFullSt, setLoadingFullSt] = useState(false);
  const [loadingDowRep, setLoadingDowRep] = useState(false);
  const [pageDetails, setPageDetails] = useState(null);
  const [pageDowRepDetails, setPageDowRepDetails] = useState(null);
  const loggedInUserName = sessionStorage.getItem("username") || "admin";
  const [currentPage, setCurrentPage] = useState(1);
  const [filterData, setFilterData] = useState(defaultFilterData);
  const [columnData, setColumnData] = useState("");
  const [isModalOpenReport, setIsModalOpenReport] = useState(false);
  const [isModalOpenReportDown, setIsModalOpenReportDown] = useState(false);
  const [downloadReportData, setDownloadReportData] = useState([]);

  const dispatch = useDispatch();

  const openModalReport = () => {
    setIsModalOpenReport(true);
  };

  const closeModalReport = () => {
    setIsModalOpenReport(false);
  };
  const openModalReportDown = () => {
    setIsModalOpenReportDown(true);
  };

  const closeModalReportDown = () => {
    setIsModalOpenReportDown(false);
  };

  const handleReset = () => {
    setFilterData(defaultFilterData);
  };

  const [isModalOpenFilter, setIsModalOpenFilter] = useState(false);
  const openModalFilter = () => {
    setIsModalOpenFilter(true);
  };

  const closeModalFilter = () => {
    setIsModalOpenFilter(false);
  };

  const ledgerHeader = [
    "Company Id",
    "Company Name",
    "Transaction Date",
    "Amount (₹)",
    "Dr/Cr",
    "Balance (₹)",
    "RRN",
    "Narration",
    "Transaction Type",
    "Created By",
    "Created Date",
  ];

  const ledgerHeaderToKeyMap = {
    "Company Id": "companyId",
    "Company Name": "companyName",
    "Transaction Date": "txnDate",
    "Amount (₹)": "amount",
    "Dr/Cr": "drcr",
    "Balance (₹)": "balance",
    RRN: "rrn",
    Narration: "narration",
    "Transaction Type": "txnType",
    "Created By": "createdBy",
    "Created Date": "createdDate",
  };

  useEffect(() => {
    fetchLedgerData(1, filterData);
    // fetchDashboardData();
  }, []);

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  const fetchLedgerData = async (currentPage, filterData) => {
    try {
      const requestBody = {
        username: loggedInUserName,
        ...filterData,
        drcr: filterData?.drcr?.label || "",
        // the backend reads drCr (DR / CR)
        drCr: filterData?.drCr || "",
        fromDate: formatDate(filterData?.fromDate),
        toDate: formatDate(filterData?.toDate),
      };

      const response = await axiosPostApi(
        `${apiList.FETCH_LEDGER_MASTER_DATA}?&pageSize=${pageSize}&pageNo=${currentPage}`,
        requestBody
      );

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setPageDetails(response?.data?.pageDetails);

        const modifiedData = modifyStructure(response?.data?.data);

        setLedgerData(modifiedData);
        if (modifiedData?.length === 0) {
          setNoData(true);
        } else {
          setNoData(false);
        }
        fetchDashboardData();
      } else {
        setNoData(true);
        setLedgerData([]);

        // "01" is just "no matches": the empty table says so
        if (response?.data?.respCode !== "01" && response?.data?.data !== null) {
          CustomAlert({
            title: "No Data",
            text: "No data available for the specified criteria.",
            icon: "info",
            confirmButtonText: "Okay",
          });
        }
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      }).then((result) => {
        if (result.isConfirmed) {
          sessionStorage.clear();
          window.location.href = "/";
        }
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchDashboardData = () => {
    const endDate = formatDateToYYYYMMDD(new Date());
    const startDate1 = new Date(new Date().setDate(new Date().getDate() - 90));
    const finalStartDate = formatDateToYYYYMMDD(startDate1);

    const requestBody = {
      startDate: finalStartDate,
      endDate: endDate,
      username: loggedInUserName,
    };

    axiosPostApi(apiList.DASHBOARD_DATA, requestBody)
      .then((response) => {
        if (response?.status === 200 && response?.data?.respCode === "00") {
          dispatch(setBalance(response?.data?.data));
          fetchData(1);
        } else {
          console.warn("Dashboard data fetch failed:", response?.data?.message);
        }
      })
      .catch((error) => {
        console.error("Error fetching dashboard data:", error);
      });
  };

  const modifyStructure = (response) => {
    const modified = response?.map((user, index) => {
      const transDateParsed = user?.txnDate
        ? parse(user.txnDate, "dd-MM-yyyy HH:mm:ss", new Date())
        : null;

      const CreatedDateParsed = user?.createdDate
        ? parse(user.createdDate, "dd-MM-yyyy HH:mm:ss", new Date())
        : null;

      const formattedAmount =
        user?.amount !== undefined ? Number(user.amount).toFixed(2) : "";

      const formattedBalance =
        user?.balance !== undefined ? Number(user.balance).toFixed(2) : "";

      const formattedRrn = user?.rrn ? (
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "visible",
            textOverflow: "clip",
          }}
        >
          {user?.rrn}
        </td>
      ) : (
        ""
      );

      return {
        ...user,
        id: index + 1,

        txnDate: transDateParsed
          ? [
              format(transDateParsed, "dd-MM-yyyy"),
              <br key={index} />,
              format(transDateParsed, "HH:mm:ss"),
            ]
          : "",

        createdDate: CreatedDateParsed
          ? [
              format(CreatedDateParsed, "dd-MM-yyyy"),
              <br key={index} />,
              format(CreatedDateParsed, "HH:mm:ss"),
            ]
          : "",

        rrn: formattedRrn ? formattedRrn : "",

        amount: formattedAmount,

        balance: formattedBalance,
      };
    });

    return modified;
  };

  const handleAuthorization = (data) => {
    console.log("::data::", data);
  };

  const handleCustomer = (data, actionType = "view") => {
    setModalAction(actionType);
    setColumnData(data);
    if (actionType === "auth") {
      let custData = ledgerData.find((item) => item?.id === data?.id);
      if (custData) {
        setEditData(custData);
      }
    } else {
      let custData = ledgerData.find((item) => item?.id === data?.id);
      if (custData) {
        setEditData(custData);
      }
    }
  };

  const handleFullStatement = async (fromDate, toDate) => {
    try {
      setLoadingFullSt(true);
      const payload = {
        username: user?.data?.username,
        fromDate,
        toDate,
      };

      const response = await axiosPostApi(
        `${apiList.LEDGER_REPORT_DOWNLOAD_HISTORY}`,
        payload
      );

      if (response.status === 200 && response.data.status === true) {
        CustomAlert({
          title: "Success",
          text: response?.data?.message || "Success",
          icon: "success",
          confirmButtonText: "Ok",
        });
        closeModalReport();

        const canvas = document.createElement("canvas");
        canvas.style.position = "fixed";
        canvas.style.top = "0";
        canvas.style.left = "0";
        canvas.style.width = "100%";
        canvas.style.height = "100%";
        canvas.style.zIndex = "3000";
        document.body.appendChild(canvas);

        const confettiInstance = confetti.create(canvas, {
          resize: true,
          useWorker: true,
        });

        confettiInstance({
          particleCount: 250,
          spread: 100,
          origin: { y: 0.6 },
        });

        setTimeout(() => {
          document.body.removeChild(canvas);
        }, 3000);
      } else {
        setNoData(true);
        fetchLedgerData([]);

        if (response?.data?.data !== null) {
          CustomAlert({
            title: "Failed",
            text: response?.data?.message || "Failed",
            icon: "error",
            confirmButtonText: "Retry",
          });
        }
      }
      setLoadingFullSt(false);
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while processing.",
        icon: "error",
        confirmButtonText: "Retry",
      }).then((result) => {
        if (result.isConfirmed) {
          sessionStorage.clear();
          window.location.href = "/";
        }
      });
    } finally {
      setLoadingFullSt(false);
    }
  };

  const handleDownloadReport = async (currentPage) => {
    setLoadingDowRep(true);
    setNoDowRepData(false);

    try {
      const requestBody = {
        username: user?.data?.username,
      };

      const response = await axiosPostApi(
        `${apiList.LEDGER_REPORT_DOWNLOAD_HISTORY_LIST}?&pageSize=${pageSize}&pageNo=${currentPage}`,
        requestBody
      );

      if (response && response.data) {
        if (response.data.status === true && response.data.respCode === "00") {
          const downloadHistory = response.data.data;
          setPageDowRepDetails(response.data.pageDetails);
          setDownloadReportData(downloadHistory || []);

          if (!downloadHistory || downloadHistory.length === 0) {
            setNoDowRepData(true);
          } else {
            setNoDowRepData(false);
          }
        } else {
          setDownloadReportData([]);
          setNoDowRepData(true);

          CustomAlert({
            title: "Failed",
            text: response.data.message || "Failed to fetch data",
            icon: "error",
            confirmButtonText: "Retry",
          });
        }
      } else {
        setDownloadReportData([]);
        setNoDowRepData(true);
      }
    } catch (error) {
      console.error("Error fetching download history:", error);
      setDownloadReportData([]);
      setNoDowRepData(true);

      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoadingDowRep(false);
    }
  };

  const pageSizeCount = pageDetails === null ? 0 : pageDetails.pageSize;
  const totalRecord = pageDetails === null ? 0 : pageDetails.totalRecords;

  return (
    <>
      <HeaderWithBreadcrumb title="Ledger" breadcrumb="SMS" />
      <FilterBar
        values={filterData}
        onChange={(next) => {
          setFilterData(next);
          setCurrentPage(1);
          fetchLedgerData(1, next);
        }}
        search={{ key: "search", placeholder: "Search wallet no., user, narration, batch no. or e-way bill" }}
        selects={[{ key: "drCr", allLabel: "Debit and credit", chipLabel: "Type", options: DR_CR_OPTIONS }]}
        dateRange={{ fromKey: "fromDate", toKey: "toDate", label: "Date" }}
      />
      <div className="bg-[#FFFFFF] shadow-custom rounded-[14px] px-[10px]">
        {loading ? (
          <Loader />
        ) : (
          <>
            <MasterTable
              loading={loading}
              headers={ledgerHeader}
              data={ledgerData}
              handleAction={handleCustomer}
              filterFields={["companyName"]}
              entityType="Ledger"
              headerToKeyMap={ledgerHeaderToKeyMap}
              handleAuth={handleAuthorization}
              noData={noData}
              pageDetails={pageDetails}
              currentPage={currentPage}
              pageSize={pageSizeCount}
              totalRecord={totalRecord}
              fetchNextData={(page) => fetchLedgerData(page, filterData)}
              setCurrentPage={setCurrentPage}
              openModalFilter={openModalFilter}
              handleReset={handleReset}
              filterData={filterData}
              fetchData={() => fetchLedgerData(1, defaultFilterData)}
              openModalSms={openModalReport}
              openModalSmsDown={openModalReportDown}
              hideFilterControls
            />
          </>
        )}

        {isModalOpenFilter ? (
          <LedgeFilterModal
            show={isModalOpenFilter}
            handleClose={closeModalFilter}
            setLedgerData={setLedgerData}
            setPageDetails={setPageDetails}
            setNoData={setNoData}
            currentPage={currentPage}
            pageSize={pageSize}
            filterData={filterData}
            setFilterData={setFilterData}
            handleReset={handleReset}
          />
        ) : null}
        {isModalOpenReport ? (
          <FullStatement
            handleopenReport={isModalOpenReport}
            handleCloseReport={closeModalReport}
            callApi={handleFullStatement}
            loading={loadingFullSt}
          />
        ) : null}
        {isModalOpenReportDown ? (
          <DownloadReport
            handleopenReportDown={isModalOpenReportDown}
            handleCloseReportDown={closeModalReportDown}
            callApi={handleDownloadReport}
            data={downloadReportData}
            pageDowRepDetails={pageDowRepDetails}
            noData={noDowRepData}
            loading={loadingDowRep}
          />
        ) : null}
      </div>
    </>
  );
};

export default Ledger;
